export class SearchFiltersParams {
  text: string;
  randomSeed: string;
  features?: {
    language: string,
    propertyType: string,
    specialty: string,
    serviceArea: string,
    civicActivity: {
      childrensMiracleNetwork: boolean,
      canadianBreastCancerFoundation: boolean
    }
  }
}
